import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
export function Hero() {
  const {
    t
  } = useLanguage();
  return <section className="pt-40 pb-24 px-6" data-id="element-51">
      <div className="max-w-3xl mx-auto text-center" data-id="element-52">
        <h1 className="font-serif text-6xl md:text-7xl lg:text-8xl leading-[1.1] tracking-tight mb-8" data-id="element-53">
          {t.hero.headlineLine1} <br data-id="element-54" />
          <span className="italic text-coral" data-id="element-55">{t.hero.headlineLine2}</span>
        </h1>

        <div className="space-y-6 text-lg md:text-xl text-ink/80 max-w-2xl mx-auto leading-relaxed" data-id="element-56">
          <p data-id="element-57">
            {t.hero.p1Before}
            <em data-id="element-58">{t.hero.p1Italic}</em>
            {t.hero.p1After}
          </p>

          <p data-id="element-59">{t.hero.p2}</p>

          <p data-id="element-60">{t.hero.p3}</p>

          <p data-id="element-61">{t.hero.p4}</p>

          <p className="font-serif text-3xl italic text-ink pt-4" data-id="element-62">
            {t.hero.untilNow}
          </p>
        </div>

        <div className="mt-12" data-id="element-63">
          <button type="button" className="inline-flex items-center justify-center px-8 py-4 bg-coral text-white font-medium rounded-full hover:bg-coral/90 transition-transform hover:scale-105 active:scale-95" data-id="element-64">
            {t.hero.cta}
          </button>
        </div>
      </div>
    </section>;
}